import ContactForm from '@/components/sections/ContactForm'
import Hero from '@/components/sections/Hero'
import ImageParagraph from '@/components/sections/ImageParagraph'
import MarqueeText from '@/components/sections/MarqueeText'
import MediaGallery from '@/components/sections/MediaGallery'
import SingleParagraph from '@/components/sections/SingleParagraph'
import Spacer from '@/components/sections/Spacer'
import TextOnImage from '@/components/sections/TextOnImage'
import TripleSection from '@/components/sections/TripleSection'
import VideoSection from '@/components/sections/VideoSection'

export const sectionsMap: any = {
  hero_section: Hero,
  triple_section: TripleSection,
  image_paragraph: ImageParagraph,
  marquee_text: MarqueeText,
  video_section: VideoSection,
  spacer: Spacer,
  form: ContactForm,
  single_paragraph: SingleParagraph,
  media_gallery: MediaGallery,
  text_on_image: TextOnImage
}
